module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGl2ZWxsb18xIiBkYXRhLW5hbWU9IkxpdmVsbG8gMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjEgMjEiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojZjE1YzAwO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9LmNscy0ye2ZpbGw6I2YxNWMwMDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb25lPC90aXRsZT48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwLjUiIGN5PSIxMC41IiByPSIxMCIvPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iMTAuNSIgY3k9IjEwLjUiIHI9IjYiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/svg/orange/icone_btn-acceso.svg
// module id = +Jn1
// module chunks = 9